import type { Components, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.mixins.menuItemStyles(theme),
      gap: `${theme.spacing(1.25)} !important`,
    }),
  },
};

// ----------------------------------------------------------------------

export const menu = { MuiMenuItem };
